import React from 'react';

interface ShowMoreButtonProps {
  onClick: () => void;
  colorClass?: string;
  className?: string;
  children: React.ReactNode;
}

const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({
  onClick,
  colorClass = 'bg-pink-500 hover:bg-pink-600',
  className = '',
  children,
}) => (
  <div className="flex justify-center mt-6">
    <button
      className={`px-6 py-2 rounded-full ${colorClass} text-white font-semibold shadow-md transition-colors ${className}`}
      style={{ minWidth: '8ch', minHeight: '2.5rem' }}
      onClick={onClick}
    >
      {children}
    </button>
  </div>
);

export default ShowMoreButton;
